import { Plus } from "lucide-react";
import { Button } from "@/shared/ui/button";

interface AttributesPanelHeaderProps {
  attributesCount?: number;
  onCreateClick: () => void;
}

export function AttributesPanelHeader({
  attributesCount,
  onCreateClick,
}: AttributesPanelHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-2xl font-semibold text-ink-900">
          Attributes {attributesCount !== undefined && `(${attributesCount})`}
        </h2>
        <p className="mt-1 text-sm text-ink-600">
          Welcome to the attributes page. Here you can manage the attributes.
        </p>
      </div>
      <Button onClick={onCreateClick}>
        <Plus className="mr-2 h-4 w-4" />
        Add new attribute
      </Button>
    </div>
  );
}
